import { render, staticRenderFns } from "./BankIdInfo.vue?vue&type=template&id=45501043&lang=pug&"
import script from "./BankIdInfo.vue?vue&type=script&lang=js&"
export * from "./BankIdInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports